import {
  SetCurrentPage,
  SetHasStyleColorChanges,
  SetIsRemovingImages,
  SetIsSavingImages,
  SetIsStyleDataLoading,
  SetIsUploadingImages,
  SetLastPage,
  SetLinesheetId,
  SetProductId,
  SetProductImages,
  SetProductImagesBak,
  SetSearch,
  SetSelectedImages,
  SetStyleColors,
  SetUploadProgress,
} from './useManageImagesStore.types'

export const setCurrentPage: SetCurrentPage = ({ currentPage, set }) =>
  set &&
  set((state) => ({
    // min currentPage must be 1
    currentPage: Math.max(
      // max currentPage must be lastPage
      Math.min(currentPage, state.lastPage),
      1,
    ),
  }))

export const setHasStyleColorChanges: SetHasStyleColorChanges = ({
  hasStyleColorChanges,
  set,
}) => set && set(() => ({ hasStyleColorChanges }))

export const setIsRemovingImages: SetIsRemovingImages = ({
  isRemovingImages,
  set,
}) => set && set(() => ({ isRemovingImages }))

export const setIsSavingImages: SetIsSavingImages = ({ isSavingImages, set }) =>
  set && set(() => ({ isSavingImages }))

export const setIsUploadingImages: SetIsUploadingImages = ({
  isUploadingImages,
  set,
}) => set && set(() => ({ isUploadingImages }))

export const setLastPage: SetLastPage = ({ lastPage, set }) =>
  set &&
  set(() => ({
    // min lastPage must be 1
    lastPage: Math.max(lastPage, 1),
  }))

export const setLinesheetId: SetLinesheetId = ({ linesheetId, set }) =>
  set && set(() => ({ linesheetId }))

export const setProductId: SetProductId = ({ productId, set }) =>
  set && set(() => ({ productId }))

export const setProductImages: SetProductImages = ({ productImages, set }) =>
  set && set(() => ({ productImages }))

export const setProductImagesBak: SetProductImagesBak = ({
  productImagesBak,
  set,
}) => set && set(() => ({ productImagesBak }))

export const setSearch: SetSearch = ({ search, set }) =>
  set && set(() => ({ search }))

export const setSelectedImages: SetSelectedImages = ({ selectedImages, set }) =>
  set && set(() => ({ selectedImages }))

export const setStyleColors: SetStyleColors = ({ styleColors, set }) =>
  set && set(() => ({ styleColors }))

export const setUploadProgress: SetUploadProgress = ({ uploadProgress, set }) =>
  set && set(() => ({ uploadProgress }))

export const setIsStyleDataLoading: SetIsStyleDataLoading = ({
  isStyleDataLoading,
  set,
}) => set && set(() => ({ isStyleDataLoading }))
